import i18next from 'i18next';
import { printValue } from 'yup';

function getFieldName(path) {
  return i18next.exists(path) ? i18next.t(path) : 'Tämä kenttä';
}

export default {
  mixed: {
    default: ({ path }) => `${getFieldName(path)} on virheellinen`,
    required: ({ path }) => `${getFieldName(path)} on pakollinen kenttä`,
    defined: ({ path }) => `${getFieldName(path)} on määriteltävä`,
    notNull: ({ path }) => `${getFieldName(path)} ei voi olla null`,
    oneOf: ({ path, values }) =>
      `${getFieldName(path)} on oltava yksi seuraavista arvoista: ${i18next.t(values)}`,
    notOneOf: ({ path, values }) =>
      `${getFieldName(path)} ei saa olla yksi seuraavista arvoista: ${i18next.t(values)}`,
    notType: ({ path, type, value, originalValue }) => {
      const isCast = originalValue != null && originalValue !== value;
      let msg =
        `${getFieldName(path)} on oltava \`${i18next.t(type)}\` tyyppiä, ` +
        `mutta lopullinen arvo oli: \`${printValue(value, true)}\`` +
        (isCast
          ? ` (muunnettu arvosta \`${printValue(originalValue, true)}\`).`
          : '.');

      if (value === null) {
        msg +=
          `\n Jos "null" on tarkoitettu tyhjäksi arvoksi, merkitse schema` +
          ' `.nullable()`';
      }

      return msg;
    },
  },
  string: {
    length: ({ path, length }) =>
      `${getFieldName(path)} on oltava täsmälleen ${length} merkkiä`,
    min: ({ path, min }) =>
      `${getFieldName(path)} on oltava vähintään ${min} merkkiä`,
    max: ({ path, max }) =>
      `${getFieldName(path)} saa olla enintään ${max} merkkiä`,
    matches: ({ path, regex }) =>
      `${getFieldName(path)} on vastattava seuraavaa: "${regex}"`,
    email: ({ path }) =>
      `${getFieldName(path)} on oltava kelvollinen sähköpostiosoite`,
    url: ({ path }) => `${getFieldName(path)} on oltava kelvollinen URL`,
    uuid: ({ path }) => `${getFieldName(path)} on oltava kelvollinen UUID`,
    trim: ({ path }) => `${getFieldName(path)} on oltava trimmaty merkkijono`,
    lowercase: ({ path }) =>
      `${getFieldName(path)} on oltava pienaakkosinen merkkijono`,
    uppercase: ({ path }) =>
      `${getFieldName(path)} on oltava suuraakkosinen merkkijono`,
  },
  number: {
    min: ({ path, min }) =>
      `${getFieldName(path)} on oltava suurempi tai yhtä suuri kuin ${min}`,
    max: ({ path, max }) =>
      `${getFieldName(path)} on oltava pienempi tai yhtä suuri kuin ${max}`,
    lessThan: ({ path, less }) =>
      `${getFieldName(path)} on oltava pienempi kuin ${less}`,
    moreThan: ({ path, more }) =>
      `${getFieldName(path)} on oltava suurempi kuin ${more}`,
    positive: ({ path }) => `${getFieldName(path)} on oltava positiivinen luku`,
    negative: ({ path }) => `${getFieldName(path)} on oltava negatiivinen luku`,
    integer: ({ path }) => `${getFieldName(path)} on oltava kokonaisluku`,
  },
  date: {
    min: ({ path, min }) =>
      `${getFieldName(path)} kentän on oltava myöhemmin kuin ${min}`,
    max: ({ path, max }) =>
      `${getFieldName(path)} kentän on oltava aikaisemmin kuin ${max}`,
  },
  object: {
    noUnknown: ({ path, unknown }) =>
      `${getFieldName(path)} kentällä on määrittelemättömiä avaimia: ${i18next.t(unknown)}`,
  },
  array: {
    min: ({ path, min }) =>
      `${getFieldName(path)} kentässä on oltava vähintään ${min} kohdetta`,
    max: ({ path, max }) =>
      `${getFieldName(path)} kentässä saa olla enintään ${max} kohdetta`,
    length: ({ path, length }) =>
      `${getFieldName(path)} on sisällettävä ${length} kohdetta`,
  },
  boolean: {
    isValue: ({ path, value }) =>
      `${getFieldName(path)} kentän on oltava ${i18next.t(value)}`,
  },
};
